import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../slices/authSlice";
import userReducer from "../slices/userSlice";
import descriptorsReducer from "../components/DocProcessing/Descriptors/descriptors.slice";
import homeReducer from "../components/DocProcessing/Home/home.slice";
import mediaReducer from "../components/DocProcessing/Media/media.slice";
import highlightsReducer from "../components/DocProcessing/Highlights/highlights.slice";
import analyzeReducer from "../components/DocProcessing/Analyze/analyze.slice";
import memoReducer from "../components/DocProcessing/Memo/memo.slice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    descriptors: descriptorsReducer,
    home: homeReducer,
    media: mediaReducer,
    highlights: highlightsReducer,
    analyze: analyzeReducer,
    memo: memoReducer,
  },
  // middleware: (gDM) => gDM({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
